import VendorNotesForm from "./VendorNotesForm";
export default VendorNotesForm;
